import React, { memo } from 'react'
import styled from 'styled-components'
import { SkeletonLoader } from '@usap/uicomponents'

const ImagePlaceholder = styled(SkeletonLoader)`
  height: 64px;
  width: 170px;
  margin: 15px;
  ${props => props.theme.mediaQuery.down('tablet-landscape')} {
    display: none;
  }
`

const StyledImage = styled.img`
  ${props => props.theme.mediaQuery.down('tablet-landscape')} {
    display: none;
  }
`

const NoVehicleImage = styled(StyledImage)`
   height: 64px;
    width: 170px;
    margin: 15px;
`

const noVehicleImageUrl = 'https://cld.partsimg.com/w_320,h_150,f_auto,c_pad/cars/vehicle-image-coming-soon.png'

const VehicleImageContainer = ({
  vehicleImage, title, selectedVehicle, isVehicleImageLoading,
}) => {
  const isLessThan2008 = selectedVehicle && parseInt(selectedVehicle.year, 10) < 2008
  const padding = isLessThan2008 ? { paddingRight: '20px' } : {}

  if (isVehicleImageLoading) {
    return (
      <ImagePlaceholder style={padding} />
    )
  }

  if (!title) return null

  if (!vehicleImage) {
    return (
      <NoVehicleImage
        src={noVehicleImageUrl}
        width="200px"
        height="94px"
        style={padding}
      />
    )
  }

  return (
    <StyledImage
      src={vehicleImage}
      width="200px"
      height="94px"
      style={padding}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null
        currentTarget.src = noVehicleImageUrl
      }}
    />
  )
}

export default memo(VehicleImageContainer)
